/**
 * Default client.
 */

module.exports = function (_) {

    var xhrClient = require('./xhr')(_);

    return function (request) {
        return (request.client || xhrClient)(request);
    };

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-resource/src/client/default.js
// module id = 199
// module chunks = 1